import React from 'react';
// third-party
import { useSelector } from 'react-redux';

// project import
import Routes from 'routes/index';
import NavigationScroll from './Navigationscroll';
import { ToastContainer } from 'react-toastify';

// ==============================|| APP ||============================== //

const AppLayout = () => {
  const customization = useSelector((state) => state.customization);

  return (
    <>
      {
        <NavigationScroll>
          <Routes />
          <ToastContainer />
        </NavigationScroll>
      }
    </>
  );
};

export default AppLayout;
